import styled from 'styled-components';

const SubTitle = styled.h2`
  font-size: 1.1em;
  font-weight: 500;
  margin-bottom: 1em;
`;

export default SubTitle;
